import { ReactElement } from 'react';

import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { LiquidStakingPoolContext } from 'modules/liquidStaking/LiquidStakingPoolContext';

import { Staking } from '../components/Staking';

export function Dashboard(): ReactElement {
  return (
    <LiquidStakingPoolContext.Provider value={LIQUID_STAKING_TOKEN_ADDRESS}>
      <Staking />
    </LiquidStakingPoolContext.Provider>
  );
}
